import { X } from "lucide-react";

import { Button } from "@/components/ui/Button";

import { type TActionDef } from "./types";

type TDataGridBulkActionsProps = {
  selectedCount: number;
  actions: TActionDef[];
  onClearSelection: () => void;
};

/** Action bar shown when one or more rows are selected. */
export function DataGridBulkActions({ selectedCount, actions, onClearSelection }: TDataGridBulkActionsProps) {
  return (
    <div className="flex flex-wrap items-center gap-3 rounded-lg border border-primary/30 bg-primary/5 px-4 py-2.5">
      <span className="text-sm font-medium text-foreground">
        {selectedCount} selected
      </span>
      <div className="flex flex-wrap gap-2">
        {actions.map((action) => (
          <Button
            key={action.label}
            size="sm"
            variant={action.variant ?? "outline"}
            onClick={action.onClick}
            disabled={action.disabled}
          >
            {action.icon}
            {action.label}
          </Button>
        ))}
      </div>
      <Button
        size="sm"
        variant="ghost"
        className="ml-auto"
        onClick={onClearSelection}
      >
        <X className="mr-1 h-4 w-4" />
        Clear
      </Button>
    </div>
  );
}
